const stations = [
  { code: 'BHI', name: 'Stasiun Bundaran HI', display_order: 1 },
  { code: 'DKA', name: 'Stasiun Dukuh Atas BNI', display_order: 2 },
  { code: 'STB', name: 'Stasiun Setiabudi Astra', display_order: 3 },
  { code: 'BNH', name: 'Stasiun Bendungan Hilir', display_order: 4 },
  { code: 'IST', name: 'Stasiun Istora Mandiri', display_order: 5 },
  { code: 'SNY', name: 'Stasiun Senayan Mastercard', display_order: 6 },
  { code: 'ASN', name: 'Stasiun ASEAN', display_order: 7 },
  { code: 'BLM', name: 'Stasiun Blok M BCA', display_order: 8 },
  { code: 'BLA', name: 'Stasiun Blok A', display_order: 9 },
  { code: 'HJN', name: 'Stasiun Haji Nawi', display_order: 10 },
  { code: 'CPR', name: 'Stasiun Cipete Raya Tuku', display_order: 11 },
  { code: 'FTM', name: 'Stasiun Fatmawati Indomaret', display_order: 12 },
  { code: 'LBB', name: 'Stasiun Lebak Bulus', display_order: 13 }
];

export default stations;
